module.exports = __webpack_public_path__ + "img/color_pencil.0e30a601.webp";